import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { products } from "../../services";
import { Arrow } from "../images";
import ProductItem from "../product/productItem";
import "./style.scss";

const RelatedProducts = (props: any) => {
  const { productId, productPath } = props;
  const [relatedProducts, setRelatedProducts] = useState<any>(null);
  const [visibleArrowLeft, setVisibleArrowLeft] = React.useState(false);
  const [visibleArrowRight, setVisibleArrowRight] = React.useState(false);
  const { t } = useTranslation();
  let slider: any = React.useRef();

  useEffect(() => {
    fetchRelatedProducts();
  }, [productId]);

  const fetchRelatedProducts = () => {
    const query = {
      product_id: productId,
      path: productPath,
      // related_cat_id: category._id,
      // childs: category.childs,
    };

    products.getRelatedProducts(query, (data, err) => {
      if (data && data.length) {
        setRelatedProducts(data);
        setVisibleArrowRight(data.length > 4 ? true : false);
      }
    });
  };

  const PrevArrow = () =>
    visibleArrowLeft ? (
      <a className={` kd-btn-arrow-left`} onClick={() => slider.slickPrev()}>
        <img src={Arrow} style={{ width: 30 }} alt="Next" />
      </a>
    ) : null;

  const NextArrow = () =>
    visibleArrowRight ? (
      <a className="kd-btn-arrow-right" onClick={() => slider.slickNext()}>
        <img
          src={Arrow}
          style={{ width: 30, transform: "scaleX(-1)" }}
          alt="Next"
        />
      </a>
    ) : null;

  const settings = {
    dots: false,
    autoplay: false,
    infinite: false,
    arrows: true,
    speed: 500,
    accessibility: true,
    initialSlide: 0,
    slidesToShow: 4,
    slidesToScroll: 4,
    rows: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    beforeChange: (current: any, next: any) => {
      setVisibleArrowLeft(false);
      setVisibleArrowRight(true);
      if (next + 4 >= relatedProducts?.length) {
        setVisibleArrowRight(false);
      }
      if (next) {
        setVisibleArrowLeft(true);
      }
    },
    responsive: [
      {
        // breakpoint: 992,
        breakpoint: 1132,
        settings: {
          // arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          beforeChange: (current: any, next: any) => {
            setVisibleArrowLeft(false);
            setVisibleArrowRight(true);
            if (next + 3 >= relatedProducts?.length) {
              setVisibleArrowRight(false);
            }
            if (next) {
              setVisibleArrowLeft(true);
            }
          },
        },
      },
      {
        // breakpoint: 768,
        breakpoint: 818,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          beforeChange: (current: any, next: any) => {
            setVisibleArrowLeft(false);
            setVisibleArrowRight(true);
            if (next + 2 >= relatedProducts?.length) {
              setVisibleArrowRight(false);
            }
            if (next) {
              setVisibleArrowLeft(true);
            }
          },
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          // rows: relatedProducts ? relatedProducts.length : 1,
          beforeChange: (current: any, next: any) => {
            setVisibleArrowLeft(false);
            setVisibleArrowRight(true);
            if (next + 1 >= relatedProducts?.length) {
              setVisibleArrowRight(false);
            }
            if (next) {
              setVisibleArrowLeft(true);
            }
          },
        },
      },
    ],
  };

  return relatedProducts && relatedProducts.length ? (
    <Row
      align="top"
      justify="center"
      className="related-product-wrapper"
      style={{ backgroundColor: "rgb(245, 245, 245)", marginTop: 0 }}>
      <Col span={24}>
        <Row
          align="middle"
          justify="space-between"
          className="related-product-title-wrapper">
          <Col>
            <span className="main-title">{t("product_related")}</span>
          </Col>
        </Row>
        <Row
          justify="center"
          align="middle"
          className="related-product-slider-wrapper">
          <Slider
            {...settings}
            ref={(c) => (slider = c)}
            className="related-product-slider">
            {relatedProducts.map((p: any, i: number) => (
              <ProductItem
                {...props}
                parentIndex={0}
                index={i}
                key={p._id}
                product={p}
                type="RELATED"
              />
            ))}
          </Slider>
        </Row>
      </Col>
    </Row>
  ) : null;
};

export default RelatedProducts;
